export enum CutLineMode {
  Extended,
  HugPerimeter,
  HugContent
}
